import { render } from "./ModelsPage.vue?vue&type=template&id=69615c60&scoped=true&ts=true"
import script from "./ModelsPage.vue?vue&type=script&lang=ts"
export * from "./ModelsPage.vue?vue&type=script&lang=ts"

import "./ModelsPage.vue?vue&type=style&index=0&id=69615c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69615c60"]])

export default __exports__